module.exports = __webpack_public_path__ + "static/media/3_5.f0df70a1.png";